module.exports = __webpack_public_path__ + "static/media/awalkarir.0557ec4d.png";